/**
 * 檔案用途區塊
 * @module route.enum
 * @purpose 定義登入與支付相關頁面的路由識別值，供導頁與流程判斷時使用。
 * @external https://innotech.atlassian.net/browse/IN-132134
 * @external https://innotech.atlassian.net/browse/IN-111889
 * @external https://innotech.atlassian.net/browse/IN-111885
 * @external https://innotech.atlassian.net/browse/IN-89368
 * @external https://innotech.atlassian.net/browse/IN-54205
 * @external https://innotech.atlassian.net/browse/IN-52157
 * @external https://innotech.atlassian.net/browse/IN-40532
 * @external https://innotech.atlassian.net/browse/IN-46601
 */

/**
 * 宣告內容用途說明與單號關聯
 * @description 集中管理可被前端流程引用的頁面代碼列舉。
 * @purpose 讓登入供應商與支付頁面以固定字串對應，避免散落硬編碼造成維護風險。
 */
export enum Page {
  Apple = 'apple',
  Google = 'google',
  FaceBook = 'fb',
  Zalo = 'zalo',
  Telegram = 'telegram',
  WalletConnect = 'walletconnect',
  Payment = 'payment',
  Passkey = 'passkey',
}

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:22:06.133Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section JSDoc annotations (top/middle/bottom) with specified titles and tags, preserved enum runtime logic unchanged, normalized external links to full Jira browse URLs using file history tickets, and omitted declaration-level @external because declarationOrigins is empty.
 */
